import { IFsMap } from '../types';

export abstract class FsMapTipsServiceProvider<TMap extends IFsMap> {
  public abstract tipAdvancedMarker: any[];
  public abstract tipAdvancedClusterMarker: any[];

  public abstract onMapLoaded(map: TMap): void;
  public abstract addToMap(): void;
  public abstract removeFromMap(): void;
}
